import { useEffect, useRef, useState } from "react";

export function useCredentialCopy() {
  const operation = useRef(0);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState<string>();

  useEffect(
    () => () => {
      operation.current += 1;
    },
    [],
  );

  const reset = () => {
    operation.current += 1;
    setCopied(false);
    setError(undefined);
  };

  const copy = ({ token }: { token: string }) => {
    const currentOperation = ++operation.current;
    setCopied(false);
    setError(undefined);

    void navigator.clipboard.writeText(token).then(
      () => {
        if (operation.current !== currentOperation) {
          return;
        }

        setCopied(true);
      },
      () => {
        if (operation.current !== currentOperation) {
          return;
        }

        setError(
          "Couldn't copy the token. Select it above and copy it manually.",
        );
      },
    );
  };

  return { copied, error, copy, reset };
}
